// import {RecentShuttleRequests} from "@src/features/shuttles/components/recent-shuttle-requests";
// import {UpcomingTimedShuttles} from "@src/features/shuttles/components/upcoming-timed-shuttles";
import {Card, CardContent, CardHeader, CardTitle,} from "@src/ui/views/card";
import {Activity, Car, Users} from "lucide-react";


export function SpaceHomeScreen() {
	return (
		<div className="flex flex-1 flex-col gap-4 p-4 md:gap-8 md:p-8">
			{/* <QuickStats/> */}
			<div className="grid gap-4 md:gap-8 lg:grid-cols-2 xl:grid-cols-3">
				{/*<RecentShuttleRequests/>*/}
				{/*<UpcomingTimedShuttles/>*/}
				Space Home
			</div>
		</div>
	);
}


function QuickStats() {
	return (
		<div className="grid gap-4 md:grid-cols-2 md:gap-8 lg:grid-cols-4">
			<Card>
				<CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
					<CardTitle className="text-sm font-medium">
						Monthly Live Shuttles Users
					</CardTitle>
					<Users className="h-4 w-4 text-muted-foreground"/>
				</CardHeader>
				<CardContent>
					<div className="text-2xl font-bold">45,231</div>
					<p className="text-xs text-muted-foreground">
						+20.1% from last month
					</p>
				</CardContent>
			</Card>
			<Card>
				<CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
					<CardTitle className="text-sm font-medium">
						Monthly Timed Shuttles Users
					</CardTitle>
					<Users className="h-4 w-4 text-muted-foreground"/>
				</CardHeader>
				<CardContent>
					<div className="text-2xl font-bold">+2350</div>
					<p className="text-xs text-muted-foreground">
						+180.1% from last month
					</p>
				</CardContent>
			</Card>
			<Card>
				<CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
					<CardTitle className="text-sm font-medium">
						Monthly Timed Shuttles
					</CardTitle>
					<Car className="h-4 w-4 text-muted-foreground"/>
				</CardHeader>
				<CardContent>
					<div className="text-2xl font-bold">+12,234</div>
					<p className="text-xs text-muted-foreground">
						+19% from last month
					</p>
				</CardContent>
			</Card>
			<Card>
				<CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
					<CardTitle className="text-sm font-medium">
						Monthly Live Shuttles Orders
					</CardTitle>
					<Activity className="h-4 w-4 text-muted-foreground"/>
				</CardHeader>
				<CardContent>
					<div className="text-2xl font-bold">+573</div>
					<p className="text-xs text-muted-foreground">
						+201 since last hour
					</p>
				</CardContent>
			</Card>
		</div>
	);
}
